// 费控
import { systemIds } from '@/shared/utils';
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['fee'], // 为了获取基础路由
    };
};
export const feeToPathNameMap = {
    fee1010: ({ businessKey }) => commonFunc(`/budget/info/detail/${businessKey}`),
    fee1020: ({ businessKey }) => commonFunc(`/projectFeeChange/apply/detail/${businessKey}`),
    fee1030: ({ businessKey }) => commonFunc(`/projectFeeChange/notice/detail/${businessKey}`),
    fee1040: ({ businessKey }) => commonFunc(`/projectFeeChange/feeApply/detail/${businessKey}`),
    fee1050: ({ businessKey, variables }) => {
        let userInfoJson = sessionStorage.getItem('USER_INFO');
        if (userInfoJson) {
            userInfoJson = JSON.parse(userInfoJson);
        }
        let type = 'approveNotice';
        if (userInfoJson.defaultCompId == variables.applyCompanyId) {
            type = 'notice';
        }
        return commonFunc(`/cliam/fee/${type}/detail/${businessKey}?type=${type == 'approveNotice' ? 'approve' : ''}`);
    },
    fee1060: ({ businessKey }) => commonFunc(`/cliam/fee/approve/detail/${businessKey}`),
    fee1070: ({ businessKey }) => commonFunc(`/cliam/period/approve/detail/${businessKey}`),
    fee1080: ({ businessKey }) => commonFunc(`/projectSign/sign/detail/${businessKey}`),
};
